import { render, staticRenderFns } from "./Facture_NEW.vue?vue&type=template&id=3fc5995c&"
import script from "./Facture_NEW.vue?vue&type=script&lang=js&"
export * from "./Facture_NEW.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports